import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class AddBlockedChannels extends AbstractRequestTask {

  constructor(group_id = '', version = 'v1') {
    super();
    this.group_id = group_id;
    this.version = version;
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'controlpin/channels/add';
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getParams() {
    const params = super.getParams();
    const group_id = this.group_id;
    const user = store.getState().user;
    const user_id = user.user_id || "";
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { user_id, group_id });
  }

  isValid(data) {
    if (data.errors || data.status == 1 || data.response === 'error') {
      return false;
    }
    return true;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default AddBlockedChannels;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/AddBlockedChannelsTask.js